import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as ContactUsSettingsActionCreators from "../../../actions/contactUsSettings.actions";
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';
import InlineTextEdit from '../../Controls/InlineTextEdit';

export interface IContactUsSettingsProps {
    contactUsSettings: CreDtos.ContactUsSettings;
    load: Function;
    upsert: Function;
    isLoading: boolean;
    isSaving: boolean;
}

interface IContactUsSettingsState {
    contactUsSettings: CreDtos.ContactUsSettings;
}

class ContactUsSettings extends React.Component<IContactUsSettingsProps, IContactUsSettingsState> {
    constructor(props: IContactUsSettingsProps) {
        super(props);
        this.state = {
            contactUsSettings: new CreDtos.ContactUsSettings()
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.props.load();
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isLoading && prevProps.isLoading) {
            this.setState({ contactUsSettings: { ...this.props.contactUsSettings } });
        } else if (!this.props.isSaving && prevProps.isSaving) {
            this.setState({ contactUsSettings: { ...this.props.contactUsSettings } });
        }
    }

    onValueChanged(fieldName: string, value: any) {
        var contactUsSettings = { ...this.state.contactUsSettings };
        contactUsSettings[fieldName] = value;
        this.setState({ contactUsSettings });
        
    }

    onSave() {
       this.props.upsert(this.state.contactUsSettings);
    }

    render() {
        let content;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else if (this.props.isSaving) {
            content = (
                <Spinner isOpen={this.props.isSaving} label="Saving" />
            );
        } else if (this.state.contactUsSettings) {
            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>Contact Us</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Right Content</label>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <InlineTextEdit source={this.state.contactUsSettings.rightHtmlText} onChange={value => this.onValueChanged("rightHtmlText", value)} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Email Recipients</label>
                                            <input type="text"
                                                className="form-control"
                                                placeholder="csv list of recipients"
                                                disabled={this.props.isSaving}
                                                value={this.state.contactUsSettings.recipientEmails}
                                                onChange={(e) => this.onValueChanged("recipientEmails", e.target.value)}
                                                maxLength={2000} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.load()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        contactUsSettings: state.contactUsSettings.contactUsSettings,
        isLoading: state.contactUsSettings.isLoading,
        isSaving: state.contactUsSettings.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            load: ContactUsSettingsActionCreators.contactUsSettingsRequest,
            upsert: ContactUsSettingsActionCreators.contactUsSettingsUpsertRequest
        },
        dispatch
    );
};


const ContactUsSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(
    ContactUsSettings
);

export default ContactUsSettingsContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/ContactUs/ContactUsSettings.tsx